import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import CategoriesPage from "@/pages/categories/page";
import ArticlesPage from "@/pages/articles/page";
import ArticleDetailPage from "@/pages/articles/detail/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/articles",
    element: <ArticlesPage />,
  },
  {
    path: "/articles/:slug",
    element: <ArticleDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;